import { render, staticRenderFns } from "./NewToken.vue?vue&type=template&id=42bdca47&scoped=true"
import script from "./NewToken.vue?vue&type=script&lang=js"
export * from "./NewToken.vue?vue&type=script&lang=js"
import style0 from "./NewToken.vue?vue&type=style&index=0&id=42bdca47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bdca47",
  null
  
)

export default component.exports